import { GradientBackground } from '@components/gradient-background'
import { Heading, Text } from '@components/ui/typography'
import React, { FC } from 'react'
import * as styles from './styles'

type BlockProps = {
  title: string
  description: string
  index: number
}

export const Block: FC<BlockProps> = ({ title, description, index }) => {
  return (
    <li className={styles.block}>
      <GradientBackground variant={index} />
      <Heading variant="h5" as="h3" className={styles.heading}>
        {title}
      </Heading>
      <Text variant="bodySmall" className={styles.text}>
        {description}
      </Text>
    </li>
  )
}
